import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  CEPInput,
  DocumentInput,
  EmailInput,
  PhoneInput,
  TextFieldComponent,
} from "../../../../components/misc/form";
import { FRow } from "../../../../globalComponents/standard";
import useAlert from "../../../../globalComponents/useAlerts";
import CustomerDetailsContext from "./context";

const FormInfo = () => {
  const navigate = useNavigate();
  const { showLoading, showAlert, dismissLoading, showConfirmDialog } =
    useAlert();
  const [editing, setEditing] = useState(false);

  const { customer: form, updateCustomer } = useContext(CustomerDetailsContext);

  const handleSubmit = async (form) => {
    updateCustomer(form, () => setEditing(false));
  };

  const handleDeactive = () => {
    showConfirmDialog({
      title: "Confirme",
      description:
        "Deseja mesmo desativar esse cliente? Todas as informações e acessos serão invalidadas após o processo.",
      onConfirm: () => updateCustomer({ active: false }, navigate("./../")),
    });
  };

  const {
    register,
    handleSubmit: formSubmit,
    control,
    setValue,
    setFocus,
    watch,
  } = useForm();

  return (
    <Paper
      elevation={3}
      sx={{
        //width: 400,
        maxHeight: "100vh", // limit height
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        onSubmit={formSubmit(handleSubmit)}
        component="form"
        sx={{
          p: 2,
          overflowY: "auto", // 🔥 enables scroll
          flex: 1, // fills available space
        }}
      >
        <Grid container spacing={2} mt={1}>
          <Grid flexGrow={1}>
            <FRow fullWidth justifyContent="space-between">
              <Typography variant="h6" mb={2} gutterBottom>
                Cliente
              </Typography>

              <FormGroup>
                <FormControlLabel
                  control={<Switch checked={editing} />}
                  label="Editar"
                  onChange={(_, checked) => setEditing(checked)}
                />
              </FormGroup>
            </FRow>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <TextFieldComponent
              name="name"
              disabled={!editing}
              defaultValue={form.name}
              control={control}
              label={"Nome"}
              fullWidth
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 8, md: 8 }}>
            <DocumentInput
              disabled={true}
              size="small"
              defaultValue={form.document}
              control={control}
              fullWidth
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>
            <TextFieldComponent
              name="birthDate"
              disabled={!editing}
              defaultValue={form.birthDate}
              control={control}
              type="date"
              label={"Data Nasc.:"}
              fullWidth
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>
            <PhoneInput
              disabled={!editing}
              defaultValue={form.phone}
              size="small"
              control={control}
              fullWidth
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 8, md: 8 }}>
            <EmailInput
              disabled={!editing}
              defaultValue={form.email}
              size="small"
              control={control}
              fullWidth
            />
          </Grid>

          <Grid flexGrow={1} size={{ xs: 12 }}>
            <Typography variant="h6" mt={2}>
              Endereço
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 8, md: 8 }}>
            <TextFieldComponent
              disabled={!editing}
              defaultValue={form.address.street}
              name="address.street"
              control={control}
              label={"Logradouro"}
              fullWidth
              required
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 4, md: 4 }}>
            <TextFieldComponent
              disabled={!editing}
              defaultValue={form.address.number}
              name="address.number"
              control={control}
              label={"Número"}
              fullWidth
              required
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <TextFieldComponent
              disabled={!editing}
              defaultValue={form.address.complement}
              name="address.complement"
              control={control}
              label={"Complemento"}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <TextFieldComponent
              disabled={!editing}
              defaultValue={form.address.reference}
              name="address.reference"
              control={control}
              label={"Referência"}
              fullWidth
              required
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 8, md: 8 }}>
            <TextFieldComponent
              disabled={!editing}
              defaultValue={form.address.neighborhood}
              name="address.neighborhood"
              control={control}
              label={"Bairro"}
              fullWidth
              required
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 4, md: 4 }}>
            <CEPInput
              disabled={!editing}
              defaultValue={form.address.zipCode}
              size="small"
              control={control}
              name="address.zipCode"
              onAddressFound={(address) => {
                Object.keys(address).forEach((key) =>
                  setValue(`address.${key}`, address[key], {
                    shouldDirty: true,
                  }),
                );
              }}
              fullWidth
              required
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <TextFieldComponent
              disabled={!editing}
              defaultValue={form.address.city}
              name="address.city"
              control={control}
              label={"Cidade"}
              fullWidth
              required
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <TextFieldComponent
              disabled={!editing}
              defaultValue={form.address.state}
              name="address.state"
              control={control}
              label={"Estado"}
              fullWidth
              required
            />
          </Grid>

          <Grid item flexGrow={1} size={{ xs: 12 }}>
            {editing && (
              <FRow fullWidth justifyContent="space-between">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{ mt: 3 }}
                >
                  Salvar
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDeactive}
                  sx={{ mt: 3 }}
                >
                  Desativar cliente
                </Button>
              </FRow>
            )}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Divider />
          </Grid>
          <Grid
            container
            justifyContent={"space-between"}
            size={{ xs: 12 }}
            flexGrow={1}
          >
            <Grid textAlign={"center"} size={{ xs: 12, md: 6, lg: 6 }}>
              <Typography variant="caption" color="textDisabled" gutterBottom>
                Cadastrado em: {new Date(form.createdAt).toLocaleString()}
                <br />({form.createdBy})
              </Typography>
            </Grid>
            <Grid textAlign={"center"} size={{ xs: 12, md: 6, lg: 6 }}>
              <Typography variant="caption" color="textDisabled" gutterBottom>
                Última alteração: {new Date(form.updatedAt).toLocaleString()}
                <br />({form.updatedBy})
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default React.memo(FormInfo);
